import clsx from 'clsx';
import PropTypes from 'prop-types';
import { forwardRef, memo } from 'react';

import { Button } from '../../button/button';
import { Icon } from '../../icons/icon';

import './carousel-arrow.scss';

export const CarouselArrowUI = forwardRef(({ className, action, iconArrowName, ...props }, ref) => (
  <Button
    ref={ref}
    aria-label={action === 'prev' ? 'Previous' : 'Next'}
    className={clsx(
      'sb-CarouselArrow',
      action === 'prev' ? 'sb-CarouselArrow-prev' : 'sb-CarouselArrow-next',
      className
    )}
    autoWidth
    {...props}>
    <Icon className="sb-CarouselArrow-icon" name={iconArrowName} />
  </Button>
));

CarouselArrowUI.propTypes = {
  className: PropTypes.string,
  action: PropTypes.oneOf(['prev', 'next']).isRequired,
  iconArrowName: PropTypes.string,
};

CarouselArrowUI.defaultProps = {
  className: undefined,
  iconArrowName: 'arrow-right',
};

export const CarouselArrow = memo(CarouselArrowUI);
